// extracted by mini-css-extract-plugin
module.exports = {"toggleButton":"styles_toggleButton__2BLvl","icon":"styles_icon__32JFA","opened":"styles_opened__cmF2V"};